import { lazy, Suspense, useState, type ReactElement } from 'react';

// `lazy`: la feature (monitor, gráfico, feed) no entra en el chunk del tablero; se descarga cuando un
// widget de compuerta dibuja su botón.
const GateOperationModal = lazy(() =>
  import('@fsd/features/gate-movements').then((m) => ({ default: m.GateOperationModal })),
);
const GateMovementsModal = lazy(() =>
  import('@fsd/features/gate-movements').then((m) => ({ default: m.GateMovementsModal })),
);

export function GateOperationSlot({
  trigger,
  movementId,
  autoOpen = false,
}: {
  trigger?: ReactElement;
  movementId: number;
  /** Abierto al montarse: la operación que el widget acaba de pedir. */
  autoOpen?: boolean;
}) {
  const [open, setOpen] = useState(autoOpen);
  // Mientras se descarga la feature el botón se ve, pero todavía no abre.
  return (
    <Suspense fallback={trigger ?? null}>
      <GateOperationModal
        movementId={movementId}
        open={open}
        onOpenChange={setOpen}
        trigger={trigger}
      />
    </Suspense>
  );
}

export function GateMovementsSlot({ trigger, gateId }: { trigger: ReactElement; gateId: string }) {
  const [open, setOpen] = useState(false);
  return (
    <Suspense fallback={trigger}>
      <GateMovementsModal gateId={gateId} open={open} onOpenChange={setOpen} trigger={trigger} />
    </Suspense>
  );
}
